import { Component, Input } from '@angular/core';
import { SalesPortalService } from 'src/app/services/sales-portal.service';
import {
  ClassificationMethod,
  SplittingMethod,
} from 'src/app/pages/sales-portal/product-group-table/product-group-table.component';

@Component({
  selector: 'two-column-table',
  templateUrl: './two-column-table.html',
  styleUrls: ['./two-column-table.less'],
})
export class TwoColumnTableComponent {
  @Input() classificationMethod: ClassificationMethod = 'PRODUCT_GROUP';
  @Input() splittingMethod: SplittingMethod = 'manualSplitting';
  @Input() dataList: any = [];

  constructor(public salesPortalService: SalesPortalService) {}
}
